import { IConfigModule } from 'build/types/configs'

const config: IConfigModule = {
  version: '2.0.0',
  allowReferral: true,
  filterPrizes: true,
  comingSoon: false,
  buttonsStart: ['xeerpa'],
  positiveLogoUrls: [],
  useSecondBackground: ['/error', '/end', '/social', '/album/:id', '/trivias', '/trivia'],
  imageStart: 'backgroundImage',
  welcome: 'ImgBackground',
  legalAgeDate: true,
  profile: {
    notShowButtonInformation: true,
  },
  routesLinks: [
    {
      path: '/profile/movements',
      text: 'MIS PUNTOS'
    },
    {
      path: '/album/redirect/Consumo/upload',
      text: 'CARGAR FOTO'
    },
    {
      path: '/album/redirect/Ticket/upload',
      text: 'CARGAR TICKET'
    },
    {
      path: '/album/redirect/Card/upload',
      text: 'PERSONALIZA TU LATA',
      rallyType: 'Card'
    },
    {
      path: '/album/redirect/Card/profile',
      text: 'VER MI CONTENIDO'
    },
    {
      path: '/album/redirect/Card/ranking',
      text: 'VER RANKING / VOTAR'
    },
    {
      path: '/prizes',
      text: 'VER LOS PREMIOS'
    },
    {
      path: 'https://dosequis.mx/',
      text: 'Volver a dosequis.mx',
      external: true
    },
    {
      path: '/profile',
      text: 'Mi información',
      small: true
    },
    {
      path: '/help',
      text: '¿Tienes alguna duda?',
      small: true
    },
    {
      path: '/terms-and-conditions',
      text: 'Ver términos y condiciones',
      small: true
    },
    {
      path: '/privacy-politics',
      text: 'Aviso de privacidad',
      small: true
    }
  ],
  routesHome: ['DosequisID'],
  dynamics: [],
  routesProfile: ['information', 'phone', 'address', 'history', 'identificacion'],
  notAvailableFields: ['instagram', 'interests', 'consumptionCenter'],
  backgroundWhite: true,
  trivia: {
    showIntroduction: true,
    interestsRequired: false
  },
  notShowFields: ['instagram'],
  loaderPulse: true,
  dontShowSocialLogin: true,
  sumasix: false,
  album: {
    Consumo: {
      list: {
        urlRedirectAlbumComplete: '/album/start',
        urlRedirectAlbumProgress: '/album/:id/upload'
      },
      upload: {
        showHowToParticipate: true,
        validate: true,
        isTakeFoto: true,
        useLoaderValidate: true,
        useCongrats: true
      },
      congrats: {
        showButton3: true,
        showButton2: false
      }
    },
    Historia: {
      list: {
        handleClick: true,
        urlRedirectAlbumProgress: '/album/:id/ranking'
      },
      ranking: {
        titleUpload: true,
        viewMore: true,
        showSocial: 'like'
      },
      imageId: {
        showSocial: 'like'
      },
      upload: {
        showHowToParticipate: true,
        validate: true,
        useLoaderValidate: true
      },
      congrats: {
        showButton3: false
      }
    },
    Ticket: {
      list: {
        urlRedirectAlbumComplete: '/album/start',
        urlRedirectAlbumProgress: '/album/:id/upload'
      },
      upload: {
        showHowToParticipate: true,
        validate: true,
        isTakeFoto: false,
        useLoaderValidate: true,
        useCongrats: true
      },
      congrats: {
        showButton3: true,
        showButton2: true
      }
    },
    Card: {
      list: {
        handleClick: true,
        urlRedirectAlbumProgress: '/album/:id/ranking'
      },
      ranking: {
        titleUpload: true,
        viewMore: true,
        showSocial: 'like'
      },
      imageId: {
        showSocial: 'like'
      },
      upload: {
        showHowToParticipate: true,
        validate: true,
        useLoaderValidate: true,
        howTakePhoto: true,
        useCongrats: true,
        useCongratsDirect: true
      },
      congrats: {
        showButton3: true
      },
      profile: {
        showSocial: 'like|share',
        profileMultimediaOutputShare: 'base64'
      }
    }
  },
  uploaderType: ['WriteText'],
  congrats: {
    showButton3: true
  },
  usePoints: true,
  signUp: {
    base: false
  },
  triviaQr: {
    showImage: false
  },
  isDosequisCard: true,
  wheel: {
    backgroundColors: ['#862310', '#FFF'],
    textColors: ['#FFF', '#862310'],
    outerBorderColor: 'transparent',
    outerBorderWidth: 0,
    innerBorderColor: '#C4281A',
    innerBorderWidth: 60,
    innerRadius: 0,
    radiusLineColor: 'transparent',
    radiusLineWidth: 0,
    fontFamily: 'Nunito',
    fontWeight: 'bold',
    fontSize: 20,
    fontStyle: 'normal',
    textDistance: 60,
    perpendicularText: true
  },
  dynamicsBottom: true,
  collections: {
    gamesStickers: true
  },
  showModalMemorama: true,
  memorama: {
    showIntroduction: true
  },
  changeIdQr: false,
  tracking: false,
  rankingDisabled: true
}

export default config
